import intersection from 'lodash-es/intersection'

import { IInputRef, IInputRefs } from '../../components/pages/account/login/IProps'

interface FormikErrors {
  [key: string]: string
}

interface FormikTouched {
  [key: string]: boolean
}

export default function focusInvalidFormField(
  errors: FormikErrors,
  touched: FormikTouched,
  inputRefs: IInputRefs
) {
  const activeElement = document.activeElement
  const inputs = ['input', 'select', 'button', 'textarea']

  if (activeElement && inputs.indexOf(activeElement.tagName.toLowerCase()) !== -1) {
    return
  }

  const invalidFields = intersection(Object.keys(errors), Object.keys(touched))

  const inputsToFocus = invalidFields
    .map((fieldName: string) => inputRefs[fieldName]!)
    .sort((a: IInputRef, b: IInputRef) => a.order - b.order)

  if (inputsToFocus.length && document.activeElement !== inputsToFocus[0]?.ref?.current) {
    inputsToFocus[0]?.ref?.current?.focus()
  }
}
